import React, { useState } from "react";
import Agentimg from "../Images/agentimg.jpg";
import axios from "axios";

interface UserDetails {
  role: string;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  phone_number: string;
  password: string;
}


function Addagent() {
  const api = process.env.REACT_APP_API_URL as string;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [profileImage, setProfileImage] = useState<File | null>(null);

  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");

  // Handle form submit
  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (!firstName || !lastName || !phone || !password) {
      setError("All fields are required.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("firstname", firstName);
      formData.append("lastname", lastName);
      formData.append("phone", phone);
      formData.append("password", password);
      if (profileImage) {
        formData.append("profileImage", profileImage);
      }

      const response = await axios.post(`${api}/auth/agents`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("response ", response)
      if (response.status == 201) {
        setSuccess("Agent added successfully!");
        setFirstName("");
        setLastName("");
        setPhone("");
        setPassword("");
        setProfileImage(null);
      } else {
        setError("Failed to add agent.");
      }
    } catch (err: any) {
      console.error("Submit failed:", err);
      setError("Unable to add agent.");
    }
  };

  return (
    <>
      <div className="w-[100%] h-auto p-8">
        <div className="w-[100%] bg-[#fff] rounded-xl ">
          <div className="w-[100%]">
            <h1 className="text-[20px] font-[700] text-[#3d434a] py-[16px] px-[24px]">
              Add New Agent
            </h1>
          </div>
          <div className="wi-[100%] border-b-[1px] border-[#c0bebe] border-dashed"></div>
          <div className=" w-full py-[16px] px-0 sm:px-[24px]">
            <div className=" w-[100%] border-[1px] border-[#000] mt-3 p-4 ">
              <div className="sm:w-[200px]  w-[100%]  mt-[-40px] bg-[#fff] ">
                <h1 className="text-[20px] font-[700] text-gray-800 py-[16px] px-[24px]">
                  Add New Agent
                </h1>
              </div>
              <img className="w-[120px]" src={Agentimg} alt="" />

              {/* Profile Image Upload */}
              <div className="flex flex-col w-full sm:w-[48%] lg:w-[32%]">
                <label
                  className="text-[18px] my-2"
                  htmlFor="profile_image"
                >
                  Profile Image (Max file size 250 KB)
                </label>
                <input
                  className="w-[100%] bg-transparent rounded-md border border-dashed border-[#c0bebe] outline-none"
                  type="file"
                  id="profile_image"
                  onChange={(e) =>
                    setProfileImage(e.target.files ? e.target.files[0] : null)
                  }
                />
              </div>

              <div className="wi-[100%] border-b-[1px] border-[#c0bebe] border-dashed my-8"></div>

              {/* Form Fields */}
              <div className="w-full flex flex-wrap gap-4 p-1 sm:p-4">
                <div className="w-full sm:w-[48%] lg:w-[32%]">
                  <label className="block text-[16px] font-medium text-[#555454] mb-1">
                    First Name
                  </label>
                  <input
                    type="text"
                    placeholder="First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed font-bold text-[#555454] border-[#c0bebe] outline-none"
                  />
                </div>

                <div className="w-full sm:w-[48%] lg:w-[32%]">
                  <label className="block text-[16px] font-medium text-[#555454] mb-1">
                    Last Name
                  </label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed font-bold text-[#555454] border-[#c0bebe] outline-none"
                  />
                </div>

                <div className="w-full sm:w-[48%] lg:w-[32%]">
                  <label className="block text-[16px] font-medium text-[#555454] mb-1">
                    Phone No.
                  </label>
                  <input
                    type="text"
                    placeholder="Phone No."
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed font-bold text-[#555454] border-[#c0bebe] outline-none"
                  />
                </div>

                <div className="w-full sm:w-[48%] lg:w-[32%]">
                  <label className="block text-[16px] font-medium text-[#555454] mb-1">
                    Password
                  </label>
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full bg-[#e9ecef] px-3 py-2 rounded-md border border-dashed font-bold text-[#555454] border-[#c0bebe] outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Show error or success */}
        {error && <p className="text-red-500 mt-2">{error}</p>}
        {success && <p className="text-green-500 mt-2">{success}</p>}

        <div className="w-[100%] py-6">
          <button
            onClick={handleSubmit}
            className="bg-[#7a70ba] text-white px-6 py-1 sm:w-[280px] w-[100%] rounded-md hover:bg-[#6a60a8] transition-all duration-200"
          >
            Submit form
          </button>
        </div>
      </div>
    </>
  );
}

export default Addagent;
